export interface RouteConfig {
  path: string;
  label: string;
  children?: RouteConfig[];
}

export const routesConfig: RouteConfig[] = [
  { path: "/", label: "home" },
  { path: "/career", label: "career" },
  { path: "/projects", label: "projects" },
  { path: "/articles", label: "articles" },
  { path: "/photos", label: "photos" },
  // { path: '/games', label: 'games' },
  { path: "/tools", label: "tools" },
  { path: "/contact", label: "contact" },
];

export const getFlatRoutes = (
  routes: RouteConfig[] = routesConfig,
): RouteConfig[] => {
  return routes.reduce<RouteConfig[]>((acc, route) => {
    acc.push(route);
    if (route.children) {
      acc.push(...getFlatRoutes(route.children));
    }
    return acc;
  }, []);
};

export const getNavigationSequence = (): RouteConfig[] => {
  return getFlatRoutes();
};

export const getPreviousRoute = (currentPath: string): RouteConfig | null => {
  const sequence = getNavigationSequence();
  const currentIndex = sequence.findIndex((r) => r.path === currentPath);
  return currentIndex > 0 ? sequence[currentIndex - 1] : null;
};

export const getNextRoute = (currentPath: string): RouteConfig | null => {
  const sequence = getNavigationSequence();
  const currentIndex = sequence.findIndex((r) => r.path === currentPath);
  return currentIndex < sequence.length - 1 ? sequence[currentIndex + 1] : null;
};
